import { StaticDateTimePicker } from "@mui/x-date-pickers"
import { DateTime } from "luxon"

type DateTimePickerFilterProps = {
    value: null | string
    setValue: (value: string | null) => void
    onClose: () => void
}

export function DateTimePickerFilter({ value, setValue, onClose }: DateTimePickerFilterProps) {
    const handleDateChange = (newValue: DateTime | null) => {
        if (newValue) {
            setValue(newValue.toString())
        } else {
            setValue(null)
        }
    }

    return (
        <StaticDateTimePicker
            value={value ? DateTime.fromISO(value) : null}
            onChange={(newValue) => handleDateChange(newValue ? DateTime.fromJSDate(newValue.toJSDate()) : null)}
            onAccept={onClose}
            slotProps={{
                toolbar: { hidden: true },
                actionBar: { actions: [] },
            }}
        />
    )
}
